import { render, staticRenderFns } from "./HistoryModule.vue?vue&type=template&id=5e89d624&scoped=true&"
import script from "./HistoryModule.vue?vue&type=script&lang=js&"
export * from "./HistoryModule.vue?vue&type=script&lang=js&"
import style0 from "./HistoryModule.vue?vue&type=style&index=0&id=5e89d624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e89d624",
  null
  
)

export default component.exports